import { DataGridProps, gridClasses } from '@mui/x-data-grid'
import { absoluteMaxSizeStyles } from '~/ui/styles/common'

const {
  columnHeader,
  cellCheckbox,
  columnHeaderCheckbox,
  cell,
  iconSeparator,
  pinnedColumns,
  virtualScrollerContent,
  main,
  virtualScroller,
  columnSeparator,
  columnHeaders,
} = gridClasses

const transparentBorderStyles = {
  borderColor: 'transparent',
  '&': {
    [`.${columnHeader}:focus, .${cell}:focus, .${cellCheckbox}:focus-within, .${columnHeaderCheckbox}:focus-within`]:
      {
        outline: 'none',
      },
  },
}

const pinnedColumnsDataGridStyles = {
  [`& .${pinnedColumns}`]: {
    backgroundImage: 'none',
    boxShadow: 'none',
    backgroundColor: 'inherit',
  },
  // hide separators on pinned columns
  [`.${gridClasses['columnHeader--pinnedLeft']} .${gridClasses['columnHeader--pinnedRight']} .${columnSeparator}:not(.${gridClasses['columnSeparator--resizable']}) .${iconSeparator}`]:
    {
      display: 'none',
    },
}

const backgroundInheritanceStyles = {
  backgroundColor: 'inherit',
  [` .${columnHeaders}`]: {
    backgroundColor: 'inherit',
  },
  [`& .${virtualScrollerContent}, .${main}, .${virtualScroller}`]: {
    // This css property prevents f.e. browser navigation with swipe gesture when user reaches the end of the container
    overscrollBehaviorX: 'contain',
    backgroundColor: 'inherit',
  },
}

export const ACTION_ROW_CLASSNAME = 'row-action-more-details'

export const commonDataGridStyles: DataGridProps['sx'] = {
  ...backgroundInheritanceStyles,
  ...pinnedColumnsDataGridStyles,
  ...transparentBorderStyles,
  ...absoluteMaxSizeStyles,
  [`& .${gridClasses.row}:hover`]: {
    [`& .${ACTION_ROW_CLASSNAME}`]: {
      display: 'flex',
    },
  },
}
